import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './BackToHomeFab.css';

/**
 * BackToHomeFab — persistent gold pill in the bottom-left of every
 * public marketing page. Gives visitors an always-available "out" so
 * they're never trapped on a deep curtain page hunting for navigation.
 *
 * Hidden on:
 *   - the Home page itself (no need to navigate to where you are)
 *   - the Coming Soon / pre-launch gate routes
 *   - all /admin and /portal routes (those have their own chrome)
 *   - the /login route
 *   - when ANY modal is open — we rely on CSS body[overflow:hidden]
 *     to suppress the pill so it doesn't fight modal close buttons.
 */
const HIDE_ON_PATHS = new Set([
  '/',
  '/home',
  '/coming-soon',
  '/welcome',
  '/login',
  '/early-access',
  '/waitlist',
  '/guest-intake',
]);

const HIDE_ON_PREFIXES = ['/admin', '/portal'];

const BackToHomeFab = () => {
  const { pathname } = useLocation();
  if (HIDE_ON_PATHS.has(pathname)) return null;
  if (HIDE_ON_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <Link
      to="/home"
      className="back-to-home-fab"
      aria-label="Back to home"
      data-testid="back-to-home-fab"
    >
      <span className="back-fab-icon" aria-hidden="true">
        <ArrowLeft size={14} strokeWidth={2.5} />
      </span>
      <span className="back-fab-label">Back to Home</span>
    </Link>
  );
};

export default BackToHomeFab;
